import { S } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatTableDataSource } from '@angular/material/table';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { DomSanitizer } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { AppHubUtilService, SharedService } from '../../shared';
import { OrdinalDatePipe } from '../../shared/pipe/ordinal-date.pipe';

interface ReleaseInformationModel {
  releaseDate: string,
  occurance: number,
  title: string,
  points: string,
  titlePointsMap: Map<string,string[]>
}

@Component({
    selector: 'app-release-note-v4',
    templateUrl: './release-note-v4.component.html',
    styleUrls: ['./release-note-v4.component.css'],
    standalone: false
})
export class ReleaseNoteV4Component implements OnInit {

  refreshData;
  refreshCalenderData;
  data;
  calenderData;
  showLoader = true;
  public releaseInfoText = "View Previous Releases";
  public currentReleaseNote = {} as ReleaseInformationModel;
  public previousReleaseNote1 = {} as ReleaseInformationModel;
  public previousReleaseNote2 = {} as ReleaseInformationModel;
  public viewPreviousReleases = false;
  selectedTabIndex:number = 0;
  selectedOption = 'release'
  tabList = ['release' , 'data','refresh-calendar'];
  isTable1Expanded: boolean = false;
  isTable2Expanded: boolean = false;

  constructor(private iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer,
    private util: AppHubUtilService,
    private sharedService: SharedService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private ordinalDatePipe: OrdinalDatePipe) {
    iconRegistry.addSvgIcon(
      'chrome',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/images/icons8-chrome.svg')
    );

    iconRegistry.addSvgIcon(
      'internet-explorer',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/images/icons8-internet-explorer.svg')
    );
  }

  refreshHeaderColumns = [
    { columnDef: 'type', header: 'Data', width: '20%', fontWeight: 'bold', cell: (element: any) => `${element.type}` },
    { columnDef: 'source', header: 'Source', width: '20%', fontWeight: 'bold', cell: (element: any) => `${element.Source}`},
    { columnDef: 'date', header: 'Data As Of', width: '15%', fontWeight: 'bold', cell: (element: any) => `${this.util.getFormatDate(element.date)}` },
    { columnDef: 'Schedule_Frequency', header: 'Frequency', width: '10%', fontWeight: 'bold', cell: (element: any) => `${element.Schedule_Frequency}`},
    { columnDef: 'Next_Refresh_Date', header: 'Next Refresh', width: '10%', fontWeight: 'bold', cell: (element: any) => `${this.util.getFormatDate(element.Next_Refresh_Date)}`},
    { columnDef: 'description', header: 'Description', width: '30%', fontWeight: 'bold', cell: (element: any) => `${element.Description}`},

  ];

  refreshHeaderColumnsCal = [
    { columnDef: 'Year', header: 'Year', width: '25%', fontWeight: 'bold', cell: (element: any) => `${element.Year}`},
    { columnDef: 'Month', header: 'Month', width: '25%', fontWeight: 'bold', cell: (element: any) => `${element.Month}` },
    // { columnDef: 'avaiableData', header: 'Available Date', width: '25%', fontWeight: 'bold', cell: (element: any) =>  `${this.util.getFormatDate(element.avaiableData)}` },
    { columnDef: 'Refreshdate', header: 'Refresh Date', width: '25%', fontWeight: 'bold', cell: (element: any) => `${this.util.getFormatDate(element.Refreshdate)}`},
  ];


  ngOnInit() {
    this.getReleaseNotes();
    this.sharedService.refreshDate().subscribe((date) => {
      this.data = date;
      this.refreshData = new MatTableDataSource(this.data);
      this.showLoader = false;
    },err => {
      
      console.error('Error fetching refresh date:', err);
      this.showLoader = false;
      this.refreshData = new MatTableDataSource([]);
    })
    this.sharedService.refreshCalenderData().subscribe((date) => {
      this.calenderData = this.sortDataByYearAndMonth(date);
      this.refreshCalenderData = new MatTableDataSource(this.calenderData);
      this.showLoader = false;
    }, err => {
      console.error('Error fetching refresh calendar data:', err);
      this.showLoader = false;
      this.refreshCalenderData = new MatTableDataSource([]);
    });
    this.activatedRoute.queryParams.subscribe((data) => {
      let keys = data ?  Object.keys(data) : [];
      
      if(keys.length > 0 && keys.includes('selectedTab')) {
        const urlTabName = this.activatedRoute.snapshot.queryParamMap.get('selectedTab');
        if(urlTabName) {
          let index = this.tabList.indexOf(urlTabName) >=0 ? this.tabList.indexOf(urlTabName) : 0;          
          this.selectedTabIndex = index;
          this.selectedOption = this.tabList.indexOf(urlTabName) >=0  ? urlTabName : 'release';

        }

        }
    });
  }

  /**
    * @author: Rohit Kadam
    * @description: Get Release Notes Details From API  
  */
  getReleaseNotes() {
    this.sharedService.getReleaseNotesData().subscribe(res => {
      if(res) {
        if(Object.keys(res).length > 0) {
          Object.keys(res).forEach(key=> {
            this.configureReleaseInfoObj(res[key],key);
            if(key == '1') {
              this.currentReleaseNote = this.configureReleaseInfoObj(res[key],key);
            }
            if(key == '2') {
              this.previousReleaseNote1 = this.configureReleaseInfoObj(res[key],key);
            }
            if(key == '3') {
              this.previousReleaseNote2 = this.configureReleaseInfoObj(res[key],key);
            }
          });
        }
      }
    })
  }

/**
  * @author: Rohit Kadam
  * @description: Configure Release Notes Object
*/
  configureReleaseInfoObj(res,i) {
    const obj : ReleaseInformationModel = {} as ReleaseInformationModel;
    obj.occurance = i;
    const pointsMap = new Map<string,string[]>();
    if(Object.keys(res).length > 0) {
      Object.keys(res).forEach(key =>{
        let arr = res[key];
        const [year, month, day] = arr[0]['release_date'].split('-').map(Number);
        obj.releaseDate = this.ordinalDatePipe.transform(new Date(Date.UTC(year, month - 1, day+1)));
        if(arr.length > 0) {
          arr = arr.map(a => a.points);
          pointsMap.set(key,arr);
        }
      })
    }
    obj.titlePointsMap  = pointsMap;
    return obj;
  }

  /**
    * @author: Rohit Kadam
    * @description: Show/Hide Previous Release Notes Details
  */
  showHideNotes() {
    this.viewPreviousReleases = !this.viewPreviousReleases;
    if(this.viewPreviousReleases) {
      this.releaseInfoText = "Latest Release Only";
    } else {
      this.releaseInfoText = "View Previous Releases";
    }
  }

  selectionTypeChange(event: MatTabChangeEvent) { 
    console.log(event)
    const selectedTab = event.index;
   
  
    switch (selectedTab) {
      case 0: // Segment tab
        this.selectedOption = 'release'
        break;
  
      case 1: // Group tab
        this.selectedOption = 'data'
        break;

        case 2: // Group tab
        this.selectedOption = 'refresh-calendar'
        break;
  

    }

      this.router.navigate([], {
        queryParams: { selectedTab: this.selectedOption}
      });
    
   }

   sortDataByYearAndMonth(data: any[]): any[] {
    const monthOrder = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return data.sort((a, b) => {
      if (!a.Year || !b.Year) {
        return !a.Year ? 1 : -1; // Push invalid entries to the end
      }

      if (b.Year !== a.Year) {
        return b.Year - a.Year;
      }

      if (!a.Month || !b.Month) {
        return !a.Month ? 1 : -1; // Push invalid entries to the end
      }

      return monthOrder.indexOf(a.Month) - monthOrder.indexOf(b.Month);
    });
  }

}
